import React from 'react';
import { casesLawyerService, GET_LAWYER_CASE_PHASES } from '@/api';
import { HeaderFilterTable, Icon } from '@/components/common';
import { useFilters } from '@/hooks';
import { useQuery } from '@tanstack/react-query';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';
import { OptionsMultiple } from '@/components/ui/comboboxMultiple';
import { useRouter } from 'next/router';

export const PhaseFilter: React.FC = () => {
	const router = useRouter();
	const { page } = router.query;
	const [filters, setFilters] = React.useState<OptionsMultiple[]>([]);

	const { setParamFilter, hasFilter, removeParaFilter } = useFilters();

	const { data: casePhases } = useQuery({
		queryKey: [GET_LAWYER_CASE_PHASES],
		queryFn: () => casesLawyerService.getCasePhases(),
	});

	React.useEffect(() => {
		if (!casePhases?.data) return;
		const initOptions: Options[] = [
			{
				label: 'View All',
				value: 'View All',
				icon: (
					<Icon
						src={Icons.list}
						width={18}
						height={18}
						className="text-primary"
					/>
				),
			},
		];

		const casesPhasesList =
			casePhases?.data.map(({ id, name }) => ({
				value: `${id}`,
				label: name,
				icon: getIcon(name),
			})) || [];

		const groupFilters: OptionsMultiple[] = [
			{
				title: '',
				options: initOptions,
			},
			{
				title: 'Case Phase',
				options: casesPhasesList,
			},
		];

		setFilters(groupFilters);
	}, [casePhases]);

	const getIcon = (name: string) => {
		let src = '';
		if (name === 'Investigation') {
			src = Icons.search;
		} else if (name === 'Applicant Intake') {
			src = Icons.tag;
		} else if (name === 'Active Case') {
			src = Icons.folderOpen;
		} else if (name === 'Settlement') {
			src = Icons.bank;
		}

		return <Icon src={src} width={18} height={18} className="text-primary" />;
	};

	const handleSelectFilters = (key: string, value: string | undefined) => {
		key === 'Case Phase'
			? setParamFilter('phase', value, page as string)
			: removeParaFilter('phase');
	};

	return (
		<HeaderFilterTable
			title="Phase"
			filterOptions={filters}
			handleClearAll={undefined}
			handleSelectMultipleFilter={handleSelectFilters}
			hasFilter={hasFilter('phase')}
			type="combo-multiple"
		/>
	);
};
